import { watch } from "vue";
import { useServices, types } from "@/lib/openapi";

import { useOrganizationManager } from "@/composables/organization-manager";
import { defineStore, storeToRefs } from "pinia";
import { ref } from "vue";
import mixpanel from "mixpanel-browser";

export const useUserStore = defineStore("user", () => {
    const { organization } = useOrganizationManager();
    const user = ref<types.User>();
    const controller = ref(new AbortController());
    const api = useServices({
        requires: {
            auth: true,
            organization: false,
            stek: false,
        },
    });

    async function updateUser() {
        controller.value.abort();
        controller.value = new AbortController();

        try {
            user.value = (
                await api.getSelfUserMeGet({ signal: controller.value.signal })
            ).data;

            mixpanel.identify(user.value?.identity);

            mixpanel.people.set_once({
                "$name": user.value?.name,
                "$email": user.value?.email,
                "role": user.value?.role,
            });
        } catch (e) {
            if (e instanceof DOMException && e.name === "AbortError") {
                // Request was aborted by the AbortController.
                return;
            } else {
                throw e;
            }
        }
    }

    function reset() {
        user.value = undefined;
    }

    // When the organization changes, the permissions for the current user
    // change as well.
    watch(
        () => organization.value?.identity,
        () => {
            updateUser();
        },
        { immediate: true }
    );

    return { user, reset };
});

export const useUserManager = () => storeToRefs(useUserStore());
